document.addEventListener("DOMContentLoaded", function() {
    const emulsifierRatios = {
        "Lecithin (Soy/Sunflower)": 0.5,
        "Mono- & Diglycerides": 0.4,
        "Polysorbate 80": 0.3,
        "Gum Arabic": 0.7,
        "Xanthan Gum": 0.2,
        "Guar Gum": 0.3
    };

    function calculateEmulsifier() {
        let volumeInput = document.getElementById("volume").value;
        let unit = document.getElementById("unit").value;
        let emulsifier = document.getElementById("emulsifier").value;

        if (!volumeInput || volumeInput <= 0) {
            alert("Please enter a valid batch size.");
            return;
        }

        let volume = unit === "oz" ? volumeInput * 29.5735 : volumeInput; // Convert ounces to ml if needed
        let ratio = emulsifierRatios[emulsifier];
        let grams = (volume * ratio) / 100;
        let ounces = grams * 0.035274; // Convert grams to ounces

        document.getElementById("result").innerHTML = `
            <h3>Recommended Emulsifier Amount:</h3>
            <p><strong>${emulsifier}:</strong> ${grams.toFixed(2)} grams (${ounces.toFixed(2)} oz)</p>
        `;
    }

    document.getElementById("emulsifier-ratio-calculator").innerHTML = `
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 8px; max-width: 400px; margin: auto; background-color: #f9f9f9;">
            <h2 style="text-align: center;">Emulsifier Ratio Calculator</h2>
            <label>Batch Size:</label>
            <input type="number" id="volume" style="width: 100%; padding: 5px; margin-bottom: 10px;">
            <select id="unit" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="ml">Milliliters (ml)</option>
                <option value="oz">Ounces (oz)</option>
            </select>
            
            <label>Choose Emulsifier:</label>
            <select id="emulsifier" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="Lecithin (Soy/Sunflower)">Lecithin (Soy/Sunflower)</option>
                <option value="Mono- & Diglycerides">Mono- & Diglycerides</option>
                <option value="Polysorbate 80">Polysorbate 80</option>
                <option value="Gum Arabic">Gum Arabic</option>
                <option value="Xanthan Gum">Xanthan Gum</option>
                <option value="Guar Gum">Guar Gum</option>
            </select>

            <button id="calculate-btn" style="width: 100%; padding: 10px; background: #FF7E00; color: white; border: none; border-radius: 5px; cursor: pointer;">
                Calculate
            </button>

            <div id="result" style="text-align: center; font-weight: bold; margin-top: 15px;"></div>
        </div>
    `;

    document.getElementById("calculate-btn").addEventListener("click", calculateEmulsifier);
});

